import { render, staticRenderFns } from "./DocumentsDanglingSection.vue?vue&type=template&id=246c7d16&scoped=true"
import script from "./DocumentsDanglingSection.vue?vue&type=script&lang=js"
export * from "./DocumentsDanglingSection.vue?vue&type=script&lang=js"
import style0 from "./DocumentsDanglingSection.vue?vue&type=style&index=0&id=246c7d16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c7d16",
  null
  
)

export default component.exports